import { SectionTitle } from "../global/SectionTitle"
import { ScrollArrows } from "./ScrollArrows"
import { Product } from "../global/Product"
import { CustomButton } from "../global/CustomButton"
import "./exploreSection.css"
import { useContext } from "react"
import { ProductsContext } from "../../contexts/ProductsContext"

export function ExploreSection() {
    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    return (
        <div className="explore-section">

            <SectionTitle title="Our Products" />
            <div className="d-flex justify-content-between">
                <p className="section-title mt-2">Explore Our Products</p>
                <div className="scroll-arrows lg-on">
                    <ScrollArrows />
                </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between explore-products mt-4">

                {
                    products && products.filter((a, j) => !a.discount && j > 6).map((e, i) => (
                        <Product
                            key={i}
                            id={e._id}
                            name={e.title}
                            image={e.image}
                            salePrice={e.salePrice}
                            regularPrice={e.regularPrice}
                            discount={e.discount && e.discount}
                            rating={e.rating.rate}
                            reviews={e.rating.reviews}
                            newProduct={e.new}
                        />
                    ))
                }

            </div>

            <div className="d-flex justify-content-center mt-5">
                <CustomButton
                    btnLink={true}
                    path="/shop"
                    text="View All Products"
                    color="primary"
                />
            </div>

        <hr />
        </div>
    )
}